if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Initialize custom price calculation
        this.initPriceCalculator();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.sizeSelect = document.querySelector(
          `select[name="options[Size]"]`
        );

        if (
          this.sizeSelect &&
          this.sizeSelect.selectedOptions[0].value.includes("Custom Dimensions")
        ) {
          if (!this.validateDimensions()) {
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        // Add custom dimensions to formData
        if (this.customDimensionsSwitch.checked) {
          const customDimensions = {
            length: this.lengthInput.value,
            width: this.widthInput.value,
            height: this.heightInput.value,
            _custom_dimensions: true,
          };
          for (const [key, value] of Object.entries(customDimensions)) {
            formData.append(`properties[${key}]`, value);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      initPriceCalculator() {
        this.customDimensionsSwitch = document.getElementById(
          `custom-dimensions-switch`
        );
        this.customDimensionsInputs = document.getElementById(
          `custom-dimensions-inputs`
        );
        this.widthInput = document.getElementById(`width`);
        this.heightInput = document.getElementById(`height`);
        this.lengthInput = document.getElementById(`length`);
        this.calculatePriceButton = document.getElementById(
          `calculate-price-button`
        );
        this.fabricSelect = document.querySelector(
          `select[name="options[Density]"]`
        ); // Updated selector
        this.sizeSelect = document.querySelector(
          `select[name="options[Size]"]`
        ); // Selector for size variant
        this.priceDisplays = document.querySelectorAll(
          ".price--in-display .price-item--regular"
        );
        this.price = document.querySelector(
          ".price-hidden .price-item--regular"
        );

        if(!this.sizeSelect || !this.sizeSelect.selectedOptions[0].value.includes("Custom Dimensions")) {
          return;
        }

        this.calculatedPrice = 0;

        if (this.sizeSelect) {
          console.log("sizeSelect: ", this.sizeSelect.selectedOptions[0].value);
          if (
            this.sizeSelect.selectedOptions[0].value.includes(
              "Custom Dimensions"
            )
          ) {
            this.customDimensionsSwitch.checked = true;
            this.submitButton.setAttribute("aria-disabled", true);
            this.toggleCustomDimensions();
          }
          this.sizeSelect.addEventListener("change", () => {
            if (
              this.sizeSelect.selectedOptions[0].value.includes(
                "Custom Dimensions"
              )
            ) {
              this.customDimensionsSwitch.checked = true;
              this.submitButton.setAttribute("aria-disabled", true);

              this.toggleCustomDimensions();
            } else {
              this.customDimensionsSwitch.checked = false;
              this.submitButton.removeAttribute("aria-disabled");
              this.toggleCustomDimensions();
            }
          });
        }

        this.customDimensionsSwitch.addEventListener(
          "change",
          this.toggleCustomDimensions.bind(this)
        );
        this.calculatePriceButton.addEventListener(
          "click",
          this.calculatePrice.bind(this)
        );
        this.widthInput.addEventListener(
          "input",
          this.validateDimensions.bind(this)
        );
        this.heightInput.addEventListener(
          "input",
          this.validateDimensions.bind(this)
        );
        this.lengthInput.addEventListener(
          "input",
          this.validateDimensions.bind(this)
        );
        this.fabricSelect.addEventListener(
          "change",
          this.calculatePrice.bind(this)
        );
        this.quantityInput = document.querySelector('input[name="quantity"]');
        this.quantityInput.addEventListener(
          "input",
          this.calculatePrice.bind(this)
        );
        this.quantityInput.addEventListener(
          "change",
          this.calculatePrice.bind(this)
        );
      }

      toggleCustomDimensions() {
        // const sizeSelectParent = this.sizeSelect.closest(
        //   ".product-form__input--dropdown"
        // );
        if (this.customDimensionsSwitch.checked) {
          this.customDimensionsInputs.style.display = "block";
          // if (sizeSelectParent) sizeSelectParent.style.display = "none"; // Hide size variant option parent
        } else {
          this.customDimensionsInputs.style.display = "none";
          // if (sizeSelectParent) sizeSelectParent.style.display = "block"; // Show size variant option parent
        }
      }

      validateDimensions() {
        let isValid = true;

        const widthValue = parseFloat(this.widthInput.value);
        const heightValue = parseFloat(this.heightInput.value);
        const lengthValue = parseFloat(this.lengthInput.value);

        if (
          !this.widthInput.value ||
          widthValue <= 0 ||
          !Number.isInteger(widthValue)
        ) {
          document.getElementById(`width-error`).style.display = "block";
          isValid = false;
        } else {
          document.getElementById(`width-error`).style.display = "none";
        }

        if (
          !this.heightInput.value ||
          heightValue <= 0 ||
          !Number.isInteger(heightValue)
        ) {
          document.getElementById(`height-error`).style.display = "block";
          isValid = false;
        } else {
          document.getElementById(`height-error`).style.display = "none";
        }

        if (
          !this.lengthInput.value ||
          lengthValue <= 0 ||
          !Number.isInteger(lengthValue)
        ) {
          document.getElementById(`length-error`).style.display = "block";
          isValid = false;
        } else {
          document.getElementById(`length-error`).style.display = "none";
        }

        if (isValid) {
          this.submitButton.removeAttribute("aria-disabled");
          this.getNewCalculatedPrice();
        } else {
          this.submitButton.setAttribute("aria-disabled", true);
        }

        return isValid;
      }

      getNewCalculatedPrice() {
        const width = parseFloat(this.widthInput.value) || 0;
        const height = parseFloat(this.heightInput.value) || 0;
        const length = parseFloat(this.lengthInput.value) || 0;
        const selectedOptionValue = this.fabricSelect.selectedOptions[0].value;
        const selectedVariant = selectedOptionValue.split(" ")[0];

        const boardFeet = (width * height * length) / 144;
        console.log("boardFeet: ", boardFeet);
        this.price = document.querySelector(
          ".price-hidden .price-item--regular"
        );
        const pricePerBoardFeet = parseFloat(
          this.price.textContent.replace(/[^0-9.]/g, "")
        );
        console.log("pricePerBoardFeet: ", pricePerBoardFeet);
        const formData = new FormData(this.form);
        const quantity = formData.get("quantity");
        this.calculatedPrice = boardFeet * pricePerBoardFeet * 100; // Multiply by 100 to convert to cents

        if(this.calculatedPrice >= 7500) {
          this.submitButton.removeAttribute("aria-disabled");
        } else {
          this.submitButton.setAttribute("aria-disabled", true);
        }
      }

      calculatePrice() {
        if (
          !this.validateDimensions() ||
          !this.customDimensionsSwitch.checked
        ) {
          return;
        }

        this.getNewCalculatedPrice();

        this.priceDisplays = document.querySelectorAll(
          ".price--in-display .price-item--regular"
        );
        this.priceDisplays.forEach((priceDisplay) => {
          priceDisplay.textContent = Shopify.formatMoney(
            this.calculatedPrice,
            Shopify.money_format
          );
        });
      }
    }
  );
}
